import { PageRequest } from '@/core/request/PageRequest';

export enum MaterialType {
  Delivered,
  Returned,
}

export const materialTypeColor = {
  [MaterialType.Delivered]: 'blue',
  [MaterialType.Returned]: 'yellow',
};

export const materialTypeLabel = {
  [MaterialType.Delivered]: 'Entrega',
  [MaterialType.Returned]: 'Devolução',
};

export interface Material {
  workOrder: number;
  workOrderComplement: number;
  id: string;
  company: string;
  licensePlate: string;
  deliveredOrReturnedMan: string;
  received: string;
  date: string;
  type: MaterialType;
}

export interface MaterialListRequest extends PageRequest {
  filter?: string;
}
